import React from 'react';
import PropTypes from 'prop-types';

import { GroupIcon, MicrophoneInvertedIcon } from '@datacamp/waffles-icons';

import Tag from 'components/Tag';

import CustomProjectIcon from 'images/learn/project.svg';

import {
  BorderedLinks,
  Child,
  Container,
  CustomIcon,
  DarkLink,
  Flex,
  Footer,
  HideAtLg,
  List,
  ListItem,
  ListLink,
  ShowAtLg,
  Title,
  Wrapper,
} from 'components/Navbar/LearnDropdownStyles';

const LearnDropdown = ({ navigationInfo }) => (
  <Wrapper>
    <Container className="js-learn-nav-link">
      <Flex>
        <Child>
          <Title className="dc-chapeau-title">Courses</Title>
          <List>
            {navigationInfo.featured_courses.map(course => (
              <ListItem key={course.slug}>
                <ListLink href={`/courses/${course.slug}`}>
                  {course.title}
                </ListLink>
              </ListItem>
            ))}
          </List>
          <DarkLink href="/courses" mt={16}>
            {`See all courses (${navigationInfo.course_count})`}
          </DarkLink>
        </Child>
        <Child>
          <Title className="dc-chapeau-title">Tracks</Title>
          <List>
            {navigationInfo.featured_tracks.map(track => (
              <ListItem key={track.slug}>
                <ListLink href={`/tracks/${track.slug}`}>
                  {track.title_with_subtitle}
                  <Tag bg={waffles => waffles.theme.colors.primaryLightest}>
                    {track.category}
                  </Tag>
                </ListLink>
              </ListItem>
            ))}
          </List>
          <div>
            <ShowAtLg>
              <BorderedLinks>
                <DarkLink href="/tracks/skill" mt={16}>
                  {`See all skill tracks (${navigationInfo.skills_track_count})`}
                </DarkLink>
                <DarkLink href="/tracks/career" mt={16}>
                  {`See all career tracks (${navigationInfo.career_track_count})`}
                </DarkLink>
              </BorderedLinks>
            </ShowAtLg>
            <HideAtLg>
              <DarkLink href="/tracks" mt={16}>
                {`See all tracks (${navigationInfo.career_track_count +
                  navigationInfo.skills_track_count})`}
              </DarkLink>
            </HideAtLg>
          </div>
        </Child>

        <Child>
          <Title className="dc-chapeau-title">Instructors</Title>
          <List>
            {navigationInfo.featured_instructors.map(instructor => (
              <ListItem key={instructor.slug}>
                <ListLink href={`/instructors/${instructor.slug}`}>
                  {instructor.full_name}
                </ListLink>
              </ListItem>
            ))}
          </List>
          <DarkLink href="/instructors" mt={16}>
            {`Meet all instructors (${navigationInfo.instructor_count})`}
          </DarkLink>
        </Child>
      </Flex>

      <Footer>
        <BorderedLinks
          borderColor={waffles => waffles.theme.colors.greyLight}
          spacing={16}
        >
          <DarkLink href="/community/">
            <GroupIcon className="icon" />
            Community
          </DarkLink>
          <DarkLink href="/projects">
            <CustomIcon src={CustomProjectIcon} width="18" />
            Projects
          </DarkLink>
          <DarkLink href="/community/podcast">
            <MicrophoneInvertedIcon className="icon" />
            Podcast
          </DarkLink>
        </BorderedLinks>
      </Footer>
    </Container>
  </Wrapper>
);

LearnDropdown.propTypes = {
  navigationInfo: PropTypes.shape({
    course_count: PropTypes.number,
    career_track_count: PropTypes.number,
    skills_track_count: PropTypes.number,
    instructor_count: PropTypes.number,
    featured_courses: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        slug: PropTypes.string,
      })
    ),
    featured_tracks: PropTypes.arrayOf(
      PropTypes.shape({
        title_with_subtitle: PropTypes.string,
        category: PropTypes.string,
        slug: PropTypes.string,
      })
    ),
    featured_instructors: PropTypes.arrayOf(
      PropTypes.shape({
        full_name: PropTypes.string,
        slug: PropTypes.string,
      })
    ),
  }).isRequired,
};

export default LearnDropdown;
